import IMask from "imask"

export {}

const init = () => {
  const fieldsWrapper = document.querySelectorAll<HTMLElement>(".f-text, .f-textarea")

  fieldsWrapper.forEach((field) => {
    const input = field.querySelector<HTMLInputElement>(".f-text__input, .f-textarea__input")
    const label = field.querySelector<HTMLLabelElement>(".f-label")

    if (!input) return

    if (input.classList.contains("--price")) {
      const maskInput = IMask(input, {
        mask: `{${input.dataset.prefix ?? ""}}number {${input.dataset.suffix ?? "Kč"}}`,
        lazy: false,
        blocks: {
          number: {
            mask: Number,
            thousandsSeparator: " ",
            radix: ',',
            mapToRadix: ['.', ','],
            autofix: true,
            max: 999999999,
          }
        },
      });

      if (!maskInput.rawInputValue) input.value = ""

      input.addEventListener("input", () => {
        if (!maskInput.rawInputValue) input.value = ""
      })
    }

    const hasPlaceholder = !!input.getAttribute("placeholder")

    const addActive = () => {
      label?.classList.add("--active")
      field.classList.add("--active")
    }

    const removeActive = () => {
      label?.classList.remove("--active")
      field.classList.remove("--active")
    }

    const isActive = () => input.value === "" && !hasPlaceholder

    const handleActive = () => {
      isActive() ? removeActive() : addActive()
    }

    input.addEventListener("focusout", handleActive)
    input.addEventListener("input", handleActive)
    input.addEventListener("focus", addActive)
    handleActive() // Init handle

    setTimeout(() => {
      const isAutofilled = input.matches(":-webkit-autofill") || input.matches(":autofill")
      if (isAutofilled) addActive()
    }, 600)
  })
}

init()
document.addEventListener("textfieldReinit", init)
